<div class="space-y-4 p-4">
    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h2 class="text-xl font-bold text-gray-800 mb-4">Earnings Overview</h2>
        <div class="grid grid-cols-2 gap-4 mb-6">
            <div class="bg-green-50 p-4 rounded-lg">
                <div class="text-2xl font-bold text-green-600">{{totalEarningsThisWeek.toFixed(2)}}</div>
                <div class="text-sm text-gray-600">This Week</div>
            </div>
            <div class="bg-blue-50 p-4 rounded-lg">
                <div class="text-2xl font-bold text-blue-600">{{totalEarningsThisMonth.toFixed(2)}}</div>
                <div class="text-sm text-gray-600">This Month</div>
            </div>
        </div>

        <div class="space-y-3">
            <div class="flex justify-between items-center py-2 border-b border-gray-100">
                <span class="text-gray-600">Today</span>
                <span class="font-semibold">{{totalEarningsToday.toFixed(2)}}</span>
            </div>
            <div class="flex justify-between items-center py-2 border-b border-gray-100">
                <span class="text-gray-600">Yesterday</span>
                <span class="font-semibold">{{totalEarningsYesterday.toFixed(2)}}</span>
            </div>
            <div class="flex justify-between items-center py-2">
                <span class="text-gray-600">All-Time</span>
                <span class="font-semibold">{{totalEarnings.toFixed(2)}}</span>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-gray-800 mb-3">Recent Transactions</h3>
        <div class="space-y-3">
            @for (transaction of recentTransactions; track transaction.batchId) {
            <div class="flex justify-between items-center py-2">
                <div>
                    <div class="font-medium">Batch #{{transaction.batchId}}</div>
                    <div class="text-sm text-gray-500">Completed on {{transaction.completedAt |
                        date:'MM/dd/yyyy'}}</div>
                </div>
                <span class="font-semibold text-green-600">+${{(transaction.actualShopperPay ||
                    transaction.estimatedShopperPay || 0).toFixed(2)}}</span>
            </div>
            } @empty {
                <div class="p-4 pt-4">
                    <p-message severity="secondary">No recent transactions found.</p-message>
                </div>
            }
        </div>
    </div>
</div>